import { render } from "./DescriptiveContent.vue?vue&type=template&id=7bb9e36b&scoped=true"
import script from "./DescriptiveContent.vue?vue&type=script&lang=js"
export * from "./DescriptiveContent.vue?vue&type=script&lang=js"

import "./DescriptiveContent.vue?vue&type=style&index=0&id=7bb9e36b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb9e36b"]])

export default __exports__